const size = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  tablet: "768px",
  tabletL: "900px",
  laptop: "1024px",
  laptopM:"1250px",
  laptopL: "1440px",
  desktop: "2560px"
};

// export const device = {
//   mobileS: `only screen and (max-width: ${size.mobileS})`,
//   mobileM: `only screen and (max-width: ${size.mobileM})`,
//   mobileL: `only screen and (max-width: ${size.mobileL})`,
//   tablet: `only screen and (max-width: ${size.tablet})`,
//   tabletL: `only screen and (max-width: ${size.tabletL})`,
//   laptop: `only screen and (max-width: ${size.laptop})`,
//   laptopM: `only screen and (max-width: ${size.laptopM})`,
//   laptopL: `only screen and (max-width: ${size.laptopL})`,
//   desktop: `only screen and (max-width: ${size.desktop})`,
//   desktopL: `only screen and (max-width: ${size.desktop})`,
// };



export const device = {
  mobileS: `only screen and (min-width: ${size.mobileS}) and (max-width: 374px)`,         // 320px to 374px
  mobileM: `only screen and (min-width:${size.mobileM}) and (max-width: 424px)`, // 375px to 424px
  mobileL: `only screen and (min-width: ${size.mobileL}) and (max-width: 767px)`, // 425px to 767px
  tablet: `only screen and (min-width: ${size.tablet}) and (max-width: 899px)`,  // 768px to 899px
  tabletL: `only screen and (min-width: ${size.tabletL}) and (max-width: 1023px)`, // 900px to 1023px
  laptop: `only screen and (min-width: ${size.laptop}) and (max-width: 1249px)`,  // 1024px to 1249px
  laptopM: `only screen and (min-width:${size.laptopM}) and (max-width: 1439px)`, // 1250px to 1439px
  laptopL: `only screen and (min-width: ${size.laptopL}) and (max-width: 2559px)`, // 1440px to 2559px
  desktop: `only screen and (min-width: ${size.desktop})`, // 2560px and above
};